export const environment = {
    production: false,
    firebaseConfig: {
        apiKey: 'AIzaSyBQz6gxLDuolFUfLmetDUHNMH5-0LMUyrk',
        authDomain: 'rq-fr-dev.firebaseapp.com',
        databaseURL: 'https://rq-fr-dev.firebaseio.com',
        projectId: 'rq-fr-dev',
        storageBucket: 'rq-fr-dev.appspot.com',
        messagingSenderId: '411868841454'
    },
    'cloudFunctionsBaseUrlComment':'For NON authenticated CloudFunction',
    cloudFunctionsBaseUrl: 'https://europe-west1-rq-fr-dev.cloudfunctions.net/',
    cloudFunctionsNames: {
        findQueteurById: 'find-queteur-by-id',
        findULDetailsByToken: 'find-ul-details-by-token',
        troncSetDepartOrRetour: 'tronc-set-depart-or-retour',
        registerQueteur: 'register-queteur',
        troncListPrepared: 'tronc-list-prepared',
        resyncQueteurIdToFirestore: 'resync-queteur-id-to-firestore',
        historiqueTroncQueteur: 'historique-tronc-queteur',
        getULPrefs: 'get-ul-prefs',
        getULStats: 'get-ul-stats',
        getULQueteurRanking: 'get-ul-queteur-ranking',
        getQueteurStats: 'get-queteur-stats'
    },
    google_maps_key: 'AIzaSyAUKcfp4BW2S5Z6WMdhpOZ4JEj92pNdczM',
    ranking_enabled: true,
    history_enabled: true,
    badges_enabled: true
};
